import AboutComp from "../../components/AboutComp";

export default function index() {

  return (
    <div>
        <AboutComp />
    </div>
  )
}